<div class="modal-header">
    <h4 class="modal-title">
        Çalışan ekle</h4>

</div>
<div class="modal-body col-12">
    <p>Çalışan bilgileri</p>
    <form [formGroup]="personForm">
        <div class="row">
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="title">İsim</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="name" formControlName="name" maxlength="30" />
                    </div>
                    <div *ngIf="personForm.get('name').invalid && personForm.get('name').touched" class="text-danger">
                        İsim zorunludur.
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="description">Soyisim</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="lastName" formControlName="lastName"
                            maxlength="50" />
                    </div>
                    <div *ngIf="personForm.get('lastName').invalid && personForm.get('lastName').touched"
                        class="text-danger">
                        Soyisim zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="department">Departman</label>
                <div class="form-group">
                    <input type="text" class="form-control" id="department" formControlName="department"
                        maxlength="50" />
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="description">Görev</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="mission" formControlName="mission" maxlength="50" />
                    </div>
                    <div *ngIf="personForm.get('mission').invalid && personForm.get('mission').touched"
                        class="text-danger">
                        Görev zorunludur.
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="description">Tel No</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber"
                            mask="(000) 000 00 00" />
                    </div>

                </div>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="tc">T.C. Kimlik No</label>
                <div class="form-group">
                    <input type="text" class="form-control" id="tc" formControlName="tc" maxlength="11" />
                </div>
            </div>
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="wage">Maaş</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="wage" formControlName="wage" />
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="startDate">İşe Başlama Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime"
                        formControlName="startDate"></ng2-flatpickr>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="description">Email</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="email" class="form-control" id="mail" formControlName="mail" />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="birthDay">Doğum Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime"
                        formControlName="birthDay"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                <label for="workingStatus">Çalışma Durumu</label>
                <div class="form-group">
                    <input type="checkbox" id="workingStatus" formControlName="workingStatus" />
                </div>
            </div>

            <div class="col-xl-3 col-md-6 col-sm-12 col-12" *ngIf="!personForm.value.workingStatus">
                <label for="leaveJob">İşten Ayrılma Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime"
                        formControlName="leaveJob"></ng2-flatpickr>
                </div>
            </div>


            <div class="col-xl-2 col-md-4 col-sm-12 col-12">
                <label for="workingDays">Çalışma Gün Sayısı (Haftalık)</label>
                <div class="form-group">
                    <input type="number" id="workingDays" class="form-control" formControlName="workingDays" />
                    <div *ngIf="personForm.get('workingDays')?.invalid && personForm.get('workingDays')?.touched"
                        class="text-danger">
                        <small *ngIf="personForm.get('workingDays')?.errors?.['min']">
                            En az 1 gün girilmelidir.
                        </small>
                        <small *ngIf="personForm.get('workingDays')?.errors?.['max']">
                            En fazla 7 gün girilmelidir.
                        </small>
                    </div>
                </div>

            </div>

            <div class="col-xl-2 col-md-4 col-sm-12 col-12">
                <label for="workingDayHours">Günlük Çalışma Saati</label>
                <div class="form-group">
                    <input type="number" id="workingDayHours" class="form-control" formControlName="workingDayHours" />
                    <div *ngIf="personForm.get('workingDayHours')?.invalid && personForm.get('workingDayHours')?.touched"
                        class="text-danger">
                        <small *ngIf="personForm.get('workingDayHours')?.errors?.['min']">
                            En az 1 saat girilmelidir.
                        </small>
                        <small *ngIf="personForm.get('workingDayHours')?.errors?.['max']">
                            En fazla 24 saat girilmelidir.
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-md-6 col-sm-12 col-12">
                <label for="emergencyContact">Acil Durum Kontağı</label>
                <div class="form-group">
                    <textarea class="form-control" id="emergencyContact" formControlName="emergencyContact"
                        maxlength="50"></textarea>
                </div>
            </div>
            <div class="col-xl-5 col-md-6 col-sm-12 col-12">
                <label for="description">Adres</label>
                <div class="form-group">
                    <div class="input-group">
                        <textarea class="form-control" id="address" formControlName="address"
                            maxlength="200"></textarea>
                    </div>
                </div>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="!personForm.valid" (click)="onSumbit()">Evet</button>
</div>